/**
 * Centralized option values for questionnaire visibility and validation.
 * Use these constants instead of hardcoded display strings so that
 * schema, engine, and helpers stay in sync.
 */
export const OPT = {
  YES: "Yes",
  NO: "No",
  OTHER: "Other",
  OFF_DISNEY_PROPERTY: "Off Disney Property",
  MIDDAY_BREAK: "Midday Break",
  NOT_INTERESTED: "Not Interested",
  PARK_COMPLETIONIST: "Park Completionist – Ride everything possible",
  INTAKE_STANDARD: "standard",
  INTAKE_FAST: "fast",
  ANNUAL_PASS: "Annual Pass",
};

export default OPT;
